import { render } from "./ValidatorScore.vue?vue&type=template&id=45c07013&scoped=true"
import script from "./ValidatorScore.vue?vue&type=script&lang=js"
export * from "./ValidatorScore.vue?vue&type=script&lang=js"

import "./ValidatorScore.vue?vue&type=style&index=0&id=45c07013&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c07013"],['__file',"resources/js/components/Validators/ValidatorScore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45c07013"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45c07013', __exports__)) {
    api.reload('45c07013', __exports__)
  }
  
  module.hot.accept("./ValidatorScore.vue?vue&type=template&id=45c07013&scoped=true", () => {
    api.rerender('45c07013', render)
  })

}


export default __exports__